import arrowRightBlack from "../../assets/arrowRight-black.svg";

const Cuenta = () => {

  return (
    <div className="m-auto md:w-[80%] min-h-screen py-3">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">Cuenta</span>
          <a className="flex justify-between mb-4 border-t-0 border-e-0 border-s-0 border-b" href="/pagos">
            <div>
              <span className="block font-bold">Pagos y cobros</span>
              <span>Tarjetas de crédito, cupones y más.</span>
            </div>

            <label className="font-bold cursor-pointer" >
              <img src={arrowRightBlack} alt="" />
              <button className="hidden"></button>
            </label>
          </a>

          <div className="flex justify-between mb-4 border-t-0 border-e-0 border-s-0 border hidden">
            <div>
              <span className="block font-bold">Impuestos</span>
              <span>Administrá la información del contribuyente y los documentos fiscales</span>
            </div>

            <label className="font-bold cursor-pointer ">
              <img src={arrowRightBlack} alt="" />
              <button className="hidden"></button>
            </label>
          </div>

          <a className="flex justify-between mb-4  border-t-0 border-e-0 border-s-0 border" href="/notificaciones">
            <div>
              <span className="block font-bold" >Notificaciones</span>
              <span>Como nos comunicamos con vos</span>
            </div>

            <label className="font-bold cursor-pointer">
              <img src={arrowRightBlack} alt="" />
              <button className="hidden"></button>
            </label>
          </a>

          <a className="flex justify-between mb-4  border-t-0 border-e-0 border-s-0 border" href="/seguridad">
            <div>
              <span className="block font-bold">Inicio de sesión y seguridad</span>
              <span>Contraseña e historial de inicios de sesión</span>
            </div>

            <label className="font-bold cursor-pointer">
              <img src={arrowRightBlack} alt="" />
              <button className="hidden"></button>
            </label>
          </a>

          <a className="flex justify-between mb-4  border-t-0 border-e-0 border-s-0 border" href="/preferencias">
            <div>
              <span className="block font-bold">Preferencias generales</span>
              <span>Idioma, moneda y zona horaria predeterminada</span>
            </div>

            <label className="font-bold cursor-pointer">
              <img src={arrowRightBlack} alt="" />
              <button className="hidden"></button>
            </label>
          </a>

        </div>
        <div></div>
      </div>
    </div>
  )
}

export default Cuenta